import PaqueteTodoFacilController from '@/controllers/PaqueteTodoFacilController';
import { getDataBase } from '@/db';
import FechaHora from '@/utils/FechaHora';
import ParametrosGeneralesDAL from './ParametrosGaneralesDAL';


export default class FacturaDAL{

    async GetIDBy(tnCliente,tcCobro ,tnDataBaseAlias){
     
        const loPaquete = new PaqueteTodoFacilController();
        try {
            const db = await getDataBase();
            const tx = db.transaction('FACTURA', 'readonly');
            const store = tx.objectStore('FACTURA');
            const index = store.index('Cliente');
            const laFacturas = await index.getAll(Number(tnCliente));
         
            //ordenar cobro descendete
            laFacturas.sort((a, b) => {
            if (a.Cobro > b.Cobro) {
                return -1; // b debería ir antes que a
            } else if (a.Cobro < b.Cobro) {
                return 1; // a debería ir antes que b
            } else {
                return 0; // son iguales
            }
            });

            //verificar si existe tnCobro
            let llExisteCobro = false;
            for (const loFacturas of laFacturas) {
                if (loFacturas.Cobro == tcCobro) {
                    llExisteCobro = true;
                    break;
                }
            }

            if (!llExisteCobro || laFacturas.length == 0) {
                loPaquete.error = 1;
                loPaquete.status = 2;
                loPaquete.message = 'No hay registro de Factura para el Cliente';
                return loPaquete;
            }

         

            loPaquete.values = laFacturas[0].Factura;
            return loPaquete;
            
        } catch (error) {
            loPaquete.error = 1;
            loPaquete.status = 2;
            loPaquete.message = 'Error: se enctro a try catch en FacturaDAL.GetIDBy';
            loPaquete.messageSistema = error.message;
            return loPaquete;
        }



    }

    async ActualizarFacturaSinMedidor(Factura, GeneracionFactura, Cliente, DataBaseAlias){
        try {
            // const db = await getDataBase();
            // const tx = db.transaction('FACTURA', 'readonly');
            // const store = tx.objectStore('FACTURA');
            // const index = store.index('Cliente');
            // const laFacturas = await index.getAll(Number(tnCliente));
    
            const db = await getDataBase();
            const tx = db.transaction('FACTURA', 'readwrite');
            const store = tx.objectStore('FACTURA');
            const laFacturas = await store.getAll(Number(Factura));

            
            const loFechaHora = new FechaHora();
            for (const loFactura of laFacturas) {
                if (loFactura.Cliente = Cliente) {
                    // laResult.push(loCliente); 
                    loFactura.FechaLectura = loFechaHora.getFecha();
                    loFactura.Hora = loFechaHora.getHora();
                    loFactura.GeneracionFactura = GeneracionFactura;

                    store.put(loFactura);
                }
            };

            await tx.done;
            return 0;
        } catch (error) {
            console.log('Error en FacturaDAL.ActualizarFacturaSinMedidor', error);
            return 1;
        }

    }


      //GeneracionFactura, Cliente, DataBaseAlias);
      async GetDatosFacturaSocio(tcGeneracionFactura, tcCliente, DataBaseAlias) {
        
        try {
       
            const db = await getDataBase();
            const tx = db.transaction('FACTURA', 'readonly');
            const store = tx.objectStore('FACTURA');
            const index = store.index('GeneracionFactura');
            const laData = await index.getAll(tcGeneracionFactura);
            const laResultados = [];

            for (const loData of laData) {
                if (loData.Cliente == tcCliente) {
                        laResultados.push(loData);
                    }
            }
              //ordenar cobro descendete
              laResultados.sort((a, b) => {
                    if (a.Cobro > b.Cobro) {
                        return -1; // b debería ir antes que a
                    } else if (a.Cobro < b.Cobro) {
                        return 1; // a debería ir antes que b
                    } else {
                        return 0; // son iguales
                    }
                });

            const laAux = [];
            laAux.push(laResultados[0]);


            await tx.done;
            return laAux;
        } catch (error) {
            console.error('Error al buscar cliente por Cliente:', error);
            return [];
        }
    }


    async GetFechaCorte(FechaEmision, Corte) {
        try {
            // Obtener los parámetros generales
            const ParametrosGeneralesDALInstance = new ParametrosGeneralesDAL();
            const laParametrosGenerales = await ParametrosGeneralesDALInstance.GetFechaCorteParaGene();
            // const laParametrosGenerales = await this.GetFechaCorteParaGene();

            const CorteMes = Number(laParametrosGenerales[0].CorteMes);
            const CorteDias = Number(laParametrosGenerales[0].CorteDias);
            Corte = Number(Corte);

            // Calcular la fecha de corte
            if (Corte + 1 >= CorteMes) {
                // Convertir FechaEmision correctamente a una fecha sin que reste un día
                const FechaEmisionStr = FechaEmision + "T00:00:00"; // Añadir hora para evitar problemas de zona horaria
                const Fecha = new Date(FechaEmisionStr);
                
                // Sumar los días al FechaEmision
                Fecha.setDate(Fecha.getDate() + CorteDias);
                
                // Formatear la fecha a "dd/mm/yyyy"
                const FechaCorte = Fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
                
                return FechaCorte;
            } else {
                return "";
            }
        } catch (error) {
            console.error('Error al obtener la fecha de corte:', error);
            return "";
        }
    }
}